export const Experience = [
    {
        id: 1,
        title: "Frontend Developer",
        company: "Macbease Connections Pvt. Ltd",
        duration: "(Jun 2025 - Present)",
        description: [
            "Developed and refined dynamic user interfaces using ReactJS and Tailwind CSS, enhancing usability across devices.",
            "Collaborated closely with UI/UX designers to implement pixel-perfect components and responsive layouts.",
            "Improved performance and load times through code splitting, lazy loading, and optimization of image assets.",
            "Maintained clean and scalable codebase using modern ES6+ JavaScript practices and reusable component architecture."
        ]
    }
];
